export default __webpack_public_path__ + "static/media/dark-explorer-logo.2d910a55.svg";